import { defineStore } from 'pinia'

export interface InputsState {
  disabled: boolean
  isVisible: boolean
  actionDisabled: boolean
  exitPressed: boolean
  actionVisible: boolean
}

const initialState = (): InputsState => ({
  disabled: true,
  isVisible: false,
  actionDisabled: false,
  exitPressed: false,
  actionVisible: false
})

export const inputsState = defineStore('inputsState', {
  state: initialState
})